/**
 *  Copyright (C) 2006-2026 Talend Inc. - www.talend.com
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
import React from 'react';
import PropTypes from 'prop-types';

const DatasetContext = React.createContext({ datasets: [] });

class Provider extends React.Component {
	static propTypes = {
		value: PropTypes.object,
		datastore: PropTypes.object,
		children: PropTypes.node,
	};
	constructor(props) {
		super(props);
		this.state = {
			datasets: props.value || [],
			datastore: props.datastore,
		};
		this.state.add = (dataset, callback) => {
			if (!dataset.name) {
				throw new Error('Dataset name is required');
			}
			this.setState(prevState => {
				const exists = prevState.datasets.find(d => d.name === dataset.name);
				if (exists) {
					throw new Error('Dataset name is required');
				}
				// eslint-disable-next-line no-param-reassign
				prevState.datasets = prevState.datasets.concat(dataset);
				// eslint-disable-next-line no-param-reassign
				prevState.current = dataset;
				return Object.assign({}, prevState);
			}, () => {
				if (callback) {
					callback();
				}
			});
		};
		this.state.edit = (dataset, newValues) => {
			if (!newValues.name) {
				throw new Error('Dataset name is required');
			}
			this.setState(prevState => {
				const index = prevState.datasets.indexOf(dataset);
				if (index === -1) {
					throw new Error('Can t edit. Dataset not found');
				}
				Object.assign(dataset, newValues);
				return Object.assign({}, prevState);
			});
		};
		this.state.setCurrent = dataset => {
			this.setState({ current: dataset });
		};
		this.state.delete = dataset => {
			const index = this.state.datasets.indexOf(dataset);
			this.setState(prevState => {
				if (prevState.current === dataset) {
					// eslint-disable-next-line no-param-reassign
					delete prevState.current;
				}
				prevState.datasets.splice(index, 1);
				return Object.assign({}, prevState);
			});
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.datasets) {
			this.setState(nextProps.value);
		}
	}

	render() {
		return (
			<DatasetContext.Provider value={this.state}>{this.props.children}</DatasetContext.Provider>
		);
	}
}

export default {
	Provider,
	Consumer: DatasetContext.Consumer,
	raw: DatasetContext,
};
